import React from "react";
import {ModalComponent, ModalComponentProps} from 'module/Modal/component/ModalComponent';
import {useModal} from 'module/Modal/hook/useModal';
import {RequiredKeys} from 'util/types/KeyTypeUtil';

type MP = RequiredKeys<ModalComponentProps, 'modalKey'>
export type ModalProps = MP | Omit<MP, 'open' | 'onClose' | 'onFullScreen'>

export const Modal = React.memo((props: ModalProps) => {
	const {open = false, fullScreen = false, position, size, onClose, onChangedPositionSize, onFullScreen} = useModal(props.modalKey);
	return (
		<ModalComponent
			{...props}
			modalKey={props.modalKey}
			open={'open' in props ? props.open : open}
			fullScreen={'fullScreen' in props ? props.fullScreen : fullScreen}
			defaultSize={size || props.defaultSize}
			defaultPosition={position || props.defaultPosition}
			onClose={'onClose' in props ? props.onClose : onClose}
			onChangedPositionSize={onChangedPositionSize}
			onFullScreen={onFullScreen}
		>
		</ModalComponent>
	)
})
